import React, { useState } from "react";
import {
  CardWrapper,
  DeleteIcon,
  ThreeDotsContainer,
  UpdateIcon,
} from "./style";
import { Image, Button, Rate } from "antd";
import { FiMoreVertical } from "react-icons/fi";
import { FiEdit } from "react-icons/fi";
import { FiTrash2 } from "react-icons/fi";

export default ({ data, handleUpdate, handleDelete }) => {
  const [threeDotsClicked, setThreeDotsClicked] = useState(false);
  const [isFull, setIsFull] = useState(false);

  return (
    <CardWrapper>
      {threeDotsClicked && (
        <ThreeDotsContainer
          onMouseOver={() => setThreeDotsClicked(true)}
          onMouseOut={() => setThreeDotsClicked(false)}
        >
          <UpdateIcon onClick={() => handleUpdate(data)}>
            <FiEdit /> Tahrirlash
          </UpdateIcon>
          <DeleteIcon
            onClick={() => {
              handleDelete(data?.id);
            }}
          >
            <FiTrash2 /> O‘chirish
          </DeleteIcon>
        </ThreeDotsContainer>
      )}

      <div className="upper-card">
        <div className="image-and-data">
          <div className="image-wrapper">
            <Image
              crossOrigin="anonymous"
              className="ant-image"
              src={data.img}
              preview={false}
            />
          </div>

          <div className="data-wrapper">
            <Rate
              style={{ fontSize: "16px", display: "flex" }}
              // defaultValue={3}
              value={data?.rate}
              disabled={true}
            />
            <div className="member-name">
              <div>{data.full_name}</div>
            </div>
            <div className="member-position">
              <div>{data.position}</div>
            </div>
          </div>
        </div>

        <button
          className="dotsWrap"
          onClick={() =>
            threeDotsClicked
              ? setThreeDotsClicked(false)
              : setThreeDotsClicked(true)
          }
        >
          <FiMoreVertical viewBox="0 0 8 24" className="three-dots" />
        </button>
      </div>

      <div className="desc">
        {isFull ? data.desc : data?.desc?.slice(0, 50)}
        {data?.desc?.length > 50 && (
          <Button
            type="text"
            className="more"
            onClick={() => setIsFull(!isFull)}
          >
            <span>{isFull ? "kamroq" : " ko’proq"}</span>
          </Button>
        )}
      </div>
    </CardWrapper>
  );
};
